import riot from 'riot';
import events from '../src/events.js';
riot.tag2('smartkits-tabs', '<div class="section" style="margin-top: -5px; background-color: rgb(245,245,245);"> <div class="tabs is-centered is-boxed is-large"> <ul> <li each="{tab,i in tabs}" class="tab {is-active: parent.isActiveTab(tab.ref)}" onclick="{parent.toggleTab}"> <a> <span class="icon is-small"><i class="fa {tab.icon}" aria-hidden="true"></i></span> <span>{tab.title}</span> </a> </li> </ul> </div> </div> <div class="section" style="background-color: rgb(245,245,245);"> <activities class="columns is-multiline" show="{isActiveTab( \'activities\')}"></activities> <lessons class="columns is-multiline" show="{isActiveTab( \'lessons\')}"></lessons> <projects class="columns is-multiline" show="{isActiveTab( \'projects\')}"></projects> <devices class="columns is-multiline" show="{isActiveTab( \'devices\')}"></devices> </div>', '', '', function(opts) {
        var self = this;
        self.user = undefined;

        self.activeTab = "activities";

        self.on('mount', function() {
            route.start(true);
        });

        events.on('route_tab_changed', function(tab) {
            if (self.activeTab !== tab) {
                self.activeTab = tab;
                self.update();
            }
        });

        self.tabs = [{
            title: "Home",
            ref: "activities",
            icon: "fa-home"
        }, {
            title: "Lessons Library",
            ref: "lessons",
            icon: "fa-archive"
        }, {
            title: "Projects Library",
            ref: "projects",
            icon: "fa-folder-open"
        }, {
            title: "Kits",
            ref: "devices",
            icon: "fa-microchip"
        }];

        self.isActiveTab = function(tab) {
            return self.activeTab === tab;
        };

        self.toggleTab = function(e) {
            self.activeTab = e.item.tab.ref;

            routerHelpers.navigate(e.item.tab.ref);
            return true;
        };

        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
});
